
























import { Component, Vue } from "vue-property-decorator";
import CButton from "@/basics/buttons/CButton.vue";
import PrintTable from "@/basics/table/PrintTable.vue";
import QR from "qrcode";

@Component({
  components: {
    CButton,
    PrintTable
  }
})
export default class InvitationQRcode extends Vue {
  svg = "";

  print() {
    window.print();
  }

  get url(): string {
    return this.$route.query.url as string;
  }

  async mounted() {
    this.svg = await QR.toString(this.url, {
      width: 600,
      margin: 10
    });
  }
}
